import React from 'react';
import PropTypes from 'prop-types';

import 'containers/Logo/style.css';

const Logo = ({ size }) => {
  return (
    <div className="logo">
      <img src={`/logo_${size}.png?v=2`} alt="" />
    </div>
  );
};

Logo.propTypes = {
  size: PropTypes.string
};

Logo.defaultProps = {
  size: 'medium'
};

export default Logo;



// WEBPACK FOOTER //
// ./src/containers/Logo/index.js